import {
  xls,
  xlsm,
  xlsx,
} from "../../components/UploadMultipleFiles/constants";

export const SUPPORTED_TEMPLATE_FILES = "XLS, XLSX, XLSM";

export const TEMPLATE_FILE_EXTENSIONS = [xlsx, xls, xlsm];
